import type { Components, Theme } from "@mui/material/styles";

export const MuiListItemButton: Components<Theme>["MuiListItemButton"] = {
  styleOverrides: {
    root: ({ theme }: { theme: Theme }) => ({
      "&.Mui-selected": {
        borderColor: (theme.vars || theme).palette.primary.main,
        backgroundColor: (theme.vars || theme).palette.action.selected,
      },

      "&.Mui-selected:hover": {
        backgroundColor: (theme.vars || theme).palette.action.selected,
      },
    }),
  },
};
